var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeScreen === _vm.ScreensEnum.chatButton
    ? _c(
        "button",
        {
          staticClass: "btn branding-background branding-text chat-toggle",
          style: [_vm.backgroundColorStyles, _vm.foregroundColorStyles],
          attrs: { id: "" },
          on: { click: _vm.launchChat },
        },
        [
          _c("i", { staticClass: "glyphicon glyphicon-comment" }),
          _vm._v("  Chat\r\n    "),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }